import {
    openDefaultEditor,
    createDefaultImageWriter,
    getEditorDefaults,
} from '@pqina/pintura/pintura';

export default Alpine.data('animalImageEditor', (livewireInstance) => ({
    init() {
        console.log('Animal Image Editor initialized');
    },
    openEditor(mediaUrl) {
        const options = getEditorDefaults({
            imageWriter: createDefaultImageWriter({
                targetSize: {
                    width: 1028,
                    height: 1028,
                    fit: 'cover',
                },
            }),
            imageCropAspectRatio: 1,
            filePosterMaxHeight: 256,
        });

        const editor = openDefaultEditor({src: mediaUrl, ...options});
        editor.on('process', (output) => {
            const editedImage = output.dest;
            livewireInstance.upload('file', editedImage);
        });
    },
}))
